import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import { getWrapperClasses, getWrapperStyles } from './styles';
import { getIconClasses } from '../../utils/helpers';

export default function Save({ attributes }) {
  const { iconName, iconType } = attributes;

  const blockProps = useBlockProps.save({
    className: getWrapperClasses(attributes),
    style: getWrapperStyles(attributes),
  });

  const innerBlocksProps = useInnerBlocksProps.save({
    className: 'brandy-info-box__content',
  });

  const iconClasses = getIconClasses(iconName, iconType);

  return (
    <div {...blockProps}>
      {iconClasses && (
        <div className="brandy-info-box__media">
          <i className={iconClasses} aria-hidden="true" />
        </div>
      )}
      <div {...innerBlocksProps} />
    </div>
  );
}
